import React, { useEffect, useState } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './AdminOrders.css';

const ADMIN_EMAIL = 'eltonokoth59@gmail.com';

const AdminOrders = () => {
    const [processingOrders, setProcessingOrders] = useState([]);
    const [orderedOrders, setOrderedOrders] = useState([]);
    const email = localStorage.getItem('email');
    const navigate = useNavigate();

    // Redirect non-admin users
    useEffect(() => {
        if (email !== ADMIN_EMAIL) {
            navigate('/');
        }
    }, [email, navigate]);

    const fetchOrders = async () => {
        try {
            const response = await fetch('https://joshmachapi.onrender.com/api/cartitems');
            if (!response.ok) {
                throw new Error('Failed to fetch orders');
            }
            const data = await response.json();
            const processing = data.filter(order => order.order_status === 'processing');
            const ordered = data.filter(order => order.order_status === 'ordered');
            setProcessingOrders(processing);
            setOrderedOrders(ordered);
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };

    const handleCompleteOrder = async (orderId) => {
        try {
            const response = await fetch(`https://joshmachapi.onrender.com/api/cartItems/update-status/id/${orderId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ order_status: 'ordered' }),
            });

            if (!response.ok) {
                throw new Error('Failed to update order status');
            }

            // Update the order status locally
            setProcessingOrders(prevOrders => prevOrders.filter(order => order.id !== orderId));
            setOrderedOrders(prevOrders => [
                ...prevOrders,
                ...processingOrders.filter(order => order.id === orderId).map(order => ({ ...order, order_status: 'ordered' }))
            ]);
        } catch (error) {
            console.error('Error updating order status:', error);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    return (
        <Box className="myOrders">
            <Typography variant="h4" gutterBottom>
                Admin - Order Management
            </Typography>
            <Box className="orderTable">
                <Typography variant="h5" gutterBottom>
                    New Orders
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Product</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Price (Ksh)</TableCell>
                            <TableCell>Customer Email</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {processingOrders.map((order) => (
                            <TableRow key={order.id}>
                                <TableCell>{order.product_name || order.product_id}</TableCell>
                                <TableCell>{order.quantity}</TableCell>
                                <TableCell>{order.price}</TableCell>
                                <TableCell>{order.email}</TableCell>
                                <TableCell>{order.phone_number}</TableCell>
                                <TableCell>{order.order_status}</TableCell>
                                <TableCell>
                                    <Button variant="contained" color="primary" onClick={() => handleCompleteOrder(order.id)}>
                                        Complete
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
            <Box className="orderTable">
                <Typography variant="h5" gutterBottom>
                    Order History
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Product</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Price (Ksh)</TableCell>
                            <TableCell>Customer Email</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orderedOrders.map((order) => (
                            <TableRow key={order.id}>
                                <TableCell>{order.product_name || order.product_id}</TableCell>
                                <TableCell>{order.quantity}</TableCell>
                                <TableCell>{order.price}</TableCell>
                                <TableCell>{order.email}</TableCell>
                                <TableCell>{order.phone_number}</TableCell>
                                <TableCell>{order.order_status}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
};

export default AdminOrders;
